import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Css/View.css";
import axios from "axios";
import profile from "./Images/Dark Blue and Gold  Circle Logo 1 (2).png";
import API_BASE from "../config/api";

const SettingEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // ✅ FORM STATE (must be on top)
  const [formData, setFormData] = useState({
    instituteName: "",
    instituteCode: "",
    headName: "",
    mobile: "",
    email: "",
    website: "",
    address: "",
    city: "",
    district: "",
    medium: "",
    classes: "",
    teachers: "",
    students: "",
  });

  const [loading, setLoading] = useState(true);

  // ✅ SINGLE GET API
  useEffect(() => {
    if (!id) return;

    const fetchInstitute = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/Institutes/${id}`
        );

        const data = res.data;

        setFormData({
          instituteName: data.instituteName || "",
          instituteCode: data.instituteCode || "",
          headName: data.principleName || "",
          mobile: data.phoneNumber || "",
          email: data.email || "",
          website: data.website || "",
          address: data.address || "",
          city: data.city || "",
          district: data.district || "",
          medium: data.medium || "",
          classes: data.classes || "",
          teachers: data.teachers || "",
          students: data.students || "",
        });

        setLoading(false);
      } catch (error) {
        console.error("Fetch error:", error);
        setLoading(false);
      }
    };

    fetchInstitute();
  }, [id]);

  // ✅ UPDATE API
  const handleSave = async () => {
    try {
      const payload = {
        instituteName: formData.instituteName,
        instituteUniqueId: formData.instituteCode,
        principleName: formData.headName,
        address: formData.address,
        email: formData.email,
        phoneNumber: formData.mobile,
        commissionPercentage: 0,
        isActive: true,
        softwareIds: [],
      };

      await axios.put(
        `${API_BASE}/api/Institutes/${id}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Institute updated successfully");
      navigate(`/dashboard/settings/${id}`);
    } catch (error) {
      console.error("Update error:", error);
      alert("Update failed");
    }
  };

  const handleChange = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) console.log(file);
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          सेटिंग्ज &gt;&gt; <span>एडिट प्रोफाइल</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
         <button className="btn primaryy" onClick={handleSave}>
  सेव्ह करा
</button>

        </div>
      </div>

      <h2>मूलभूत माहिती एडिट करा</h2>

      <div className="profile-card">
      <div className="profile-img-wrapper">
        <img src={profile} alt="student" className="profile-img" />

        {/* Edit Icon */}
        <label className="edit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18" fill="none">
  <path d="M2 16H3.425L13.2 6.225L11.775 4.8L2 14.575V16ZM0 18V13.75L13.2 0.575C13.4 0.391667 13.6208 0.25 13.8625 0.15C14.1042 0.05 14.3583 0 14.625 0C14.8917 0 15.15 0.05 15.4 0.15C15.65 0.25 15.8667 0.4 16.05 0.6L17.425 2C17.625 2.18333 17.7708 2.4 17.8625 2.65C17.9542 2.9 18 3.15 18 3.4C18 3.66667 17.9542 3.92083 17.8625 4.1625C17.7708 4.40417 17.625 4.625 17.425 4.825L4.25 18H0ZM12.475 5.525L11.775 4.8L13.2 6.225L12.475 5.525Z" fill="#ffffff"/>
</svg>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            hidden
          />
        </label>
      </div>

      <p className="updated-text">Last Updated 12/12/2024</p>
    </div>

      <div className="info-grid">
        <div className="info-boxx">
          <label>संस्था नाव</label>
          <input
            value={formData.instituteName}
            onChange={(e) => handleChange("instituteName", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>संस्था कोड</label>
          <input
            value={formData.instituteCode}
            onChange={(e) => handleChange("instituteCode", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>प्रमुखाचे नाव</label>
          <input
            value={formData.headName}
            onChange={(e) => handleChange("headName", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>मोबाईल नं.</label>
          <input
            value={formData.mobile}
            onChange={(e) => handleChange("mobile", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>ईमेल</label>
          <input
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>वेबसाइट</label>
          <input
            value={formData.website}
            onChange={(e) => handleChange("website", e.target.value)}
          />
        </div>
      </div>

      <h2>पत्ता व ठिकाण विभाग</h2>

      <div className="info-grid">
        <div className="info-boxx">
          <label>पत्ता</label>
          <input
            value={formData.address}
            onChange={(e) => handleChange("address", e.target.value)}
          />
        </div>

        {/* <div className="info-boxx">
          <label>शहर</label>
          <input
            value={formData.city}
            onChange={(e) => handleChange("city", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>जिल्हा</label>
          <input
            value={formData.district}
            onChange={(e) => handleChange("district", e.target.value)}
          />
        </div> */}
      </div>

      <h2>शैक्षणिक माहिती विभाग</h2>

      <div className="info-grid">
        <div className="info-boxx">
          <label>माध्यम</label>
          <input
            value={formData.medium}
            onChange={(e) => handleChange("medium", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>उपलब्ध इयत्ता</label>
          <input
            value={formData.classes}
            onChange={(e) => handleChange("classes", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>एकूण शिक्षक</label>
          <input
            value={formData.teachers}
            onChange={(e) => handleChange("teachers", e.target.value)}
          />
        </div>

        <div className="info-boxx">
          <label>एकूण विद्यार्थी</label>
          <input
            value={formData.students}
            onChange={(e) => handleChange("students", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingEdit;
